import * as React from 'react';

const MenuStorageUnit = () => (
  <svg width={28} height={23} viewBox="0 0 28 23" stroke="none" strokeWidth={1} fillRule="evenodd">
    <path
      fill="#FFFFFF"
      d="M0,0 L28,0 L28,2.5 L27.473,2.5 L0.527,2.5 L0,2.5 L0,0 Z M5,23 L1,23 L1,4 L27,4 L27,23 L23,23 L23,17.924 L23,14.479 L23,11.036 L23,7.593 C23,7.178 22.403,6.5 21.989,6.5 L6.011,6.5 C5.597,6.5 5,7.178 5,7.593 L5,11.036 L5,14.479 L5,17.924 L5,23 Z"
    />
    <polygon fill="#667AC3" points="6.5 15 21.5 15 21.5 12 6.5 12" />
    <polygon fill="#667AC3" points="6.5 11 21.5 11 21.5 8 6.5 8" />
    <polygon fill="#FFFFFF" points="6.5 19 21.5 19 21.5 16 6.5 16" />
    <rect fill="#1C1F34" x={12.5} y={17} width={3} height={1} rx={0.5} />
  </svg>
);

export default MenuStorageUnit;



// WEBPACK FOOTER //
// ./src/assets/images/icons/menu-storage-unit.js